import React, { useState, useEffect, useRef } from "react";
import { FaEdit, FaPhone, FaMapMarkerAlt, FaUser } from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FiLogOut } from "react-icons/fi";
import { MdMarkEmailRead, MdShoppingBag, MdDeleteOutline } from "react-icons/md";
import ApiService, { initialAuthState } from "../Services/ApiServices";
import AddressPopupPage from "../AddressPopupPage/AddressPopupPage";
import EditProfilePopup from "../EditPorfilePopup/EdtProfilePopup";
import "./ProfilePage.css";
import MyOrders from "../MyOrders/MyOrders";
import Navbar from "../New_Templates/Navbar";
import Footer from "../New_Templates/Footer"
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useSearchParams } from "react-router-dom";
import { MdWarningAmber } from "react-icons/md";

const ProfilePage = () => {
  const [user, setUser] = useState({});
  const location = useLocation();
  const initialTab = location.state?.activeTab || "profile";
  // const [activeTab, setActiveTab] = useState(initialTab);

  const [searchParams, setSearchParams] = useSearchParams();
  const fileInputRef = useRef(null);

  const [showImageOptions, setShowImageOptions] = useState(false);
  const [imageUploading, setImageUploading] = useState(false);

  const tabFromUrl = searchParams.get("tab") || "profile";
  const [activeTab, setActiveTab] = useState(tabFromUrl);
  const [selectedImage, setSelectedImage] = useState(null);

  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [showAddressPopup, setShowAddressPopup] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [showOptionsIndex, setShowOptionsIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  // const isTestUser = user?.phoneNumber === process.env.REACT_APP_TEST_USER_NUMBER;

  const testNumbers = (process.env.REACT_APP_TEST_USER_NUMBERS || "")
    .split(",")
    .map(num => num.trim());

  const isTestUser = testNumbers.includes(user?.phoneNumber);

  const imageMenuRef = useRef(null);

  const companyCode = initialAuthState.companyCode;
  const unitCode = initialAuthState.unitCode;

  const isProfileIncomplete =
    !user?.name?.trim() ||
    !user?.email?.trim() ||
    !user?.phoneNumber?.trim();

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSearchParams({ tab });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        imageMenuRef.current &&
        !imageMenuRef.current.contains(event.target)
      ) {
        setShowImageOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const tab = searchParams.get("tab") || "profile";
    setActiveTab(tab);
  }, [searchParams]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [editProfileData, setEditProfileData] = useState({
    name: user.name || "",
    email: user.email || "",
    phoneNumber: user.phoneNumber || "",
  });

  useEffect(() => {
    fetchProfile();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { phoneNumber, email, name } = editProfileData;
    const phoneRegex = /^[6-9]\d{9}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (phoneNumber && !phoneRegex.test(phoneNumber)) {
      toast.dismiss();
      toast.error("Invalid phone number", { duration: 3000 });
      return; // 🚫 STOP API CALL
    }

    if (email && !emailRegex.test(email)) {
      toast.dismiss();
      toast.error("Invalid email format", { duration: 3000 });
      return; // 🚫 STOP API CALL
    }

    if (!name && !phoneNumber && !email) {
      toast.dismiss();
      toast.error("Please update at least one field", { duration: 3000 });
      return;
    }

    setLoading(true);

    const payload = new FormData();
    payload.append("companyCode", companyCode);
    payload.append("unitCode", unitCode);
    // payload.append("clientId", clientId);
    payload.append("name", editProfileData.name);
    payload.append("phoneNumber", editProfileData.phoneNumber);
    payload.append("email", editProfileData.email);

    try {
      const response = await ApiService.post(
        "/client/updateWebClient",
        payload,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.status) {
        toast.dismiss();
        toast.success("Profile updated successfully!", { duration: 3000 });
        fetchProfile();
      } else {
        toast.dismiss();
        toast.error(response.internalMessage || "Update failed", {
          duration: 3000,
        });
        // toast.error("Please update at least one field.", { duration: 3000 });
      }
    } catch (error) {
      console.error("Error updating profile:", error);

      toast.dismiss();

      const message =
        error?.response?.internalMessage ||   // your backend field
        error?.response?.message ||           // fallback
        "Something went wrong";

      toast.error(message, { duration: 3000 });

    } finally {
      setLoading(false);
    }
  };

  const fetchProfile = async () => {
    try {
      const response = await ApiService.post("/client/getWebClientDetailsById", {
        companyCode,
        unitCode,
        // clientId,
      });
      if (response.status) {
        setUser(response.data);
        setEditProfileData({
          name: response.data.name || "",
          email: response.data.email || "",
          phoneNumber: response.data.phoneNumber || "",
        });
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  const handleDeleteAddress = async (addressId) => {
    if (window.confirm("Are you sure you want to delete this address?")) {
      try {
        const response = await ApiService.post("/address/deleteAddress", {
          companyCode,
          unitCode,
          // clientId,
          id: addressId,
        });
        if (response.status) {
          toast.success("Address deleted successfully");
          fetchProfile();
        }
      } catch (error) {
        console.error("Failed to delete address", error);
        toast.error("Failed to delete address");
      }
    }
  };

  const handleLogout = async () => {
    try {
      await ApiService.post("/auth/logout");
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      localStorage.removeItem("client_id");
      localStorage.removeItem("client_db_id");
      localStorage.removeItem("token");
      window.location.href = "/";
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const payload = new FormData();
    payload.append("companyCode", companyCode);
    payload.append("unitCode", unitCode);
    payload.append("name", editProfileData.name);
    payload.append("phoneNumber", editProfileData.phoneNumber);
    payload.append("email", editProfileData.email);
    payload.append("photo", file);

    try {
      setImageUploading(true);

      const response = await ApiService.post(
        "/client/updateWebClient",
        payload,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.status) {
        toast.dismiss();
        toast.success("Profile image updated successfully!", {
          duration: 3000,
        });
        fetchProfile();
      } else {
        toast.dismiss();
        toast.error(response.internalMessage || "Image update failed", {
          duration: 3000,
        });
      }
    } catch (error) {
      toast.dismiss();
      toast.error("Failed to update image", { duration: 3000 });
      console.error(error);
    } finally {
      setImageUploading(false);
      setShowImageOptions(false);
    }
  };

  return (
    <div className="profile-page-container">
      {/* <Toaster position="top-center" reverseOrder={false} /> */}
      {/* <Navbar /> */}

      <div className="profile-main-content">
        <div className="profile-header">
          <h1>My Account</h1>
          <p>Manage your profile, addresses, and orders</p>
        </div>

        <div className="profile-layout">
          {/* Sidebar */}
          <div className="profile-sidebar">
            {/* <div className="user-card">
              <div className="user-avatar"
                onClick={() => fileInputRef.current.click()}
                style={{ cursor: "pointer" }}>
                {user.clientPhoto ? (
                  <img
                    src={user.clientPhoto}
                    alt="profile"
                    className="avatar-image"
                  />
                ) : (
                  <div className="avatar-placeholder">
                    <FaUser size={24} />
                  </div>
                )}
              </div>
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleImageUpload}
              />
              <div className="user-info">
                <h3>{user.name || "--"}</h3>
                <div className="user-contact">
                  <div className="contact-item">
                    <FaPhone className="contact-icon" />
                    <span>{user.phoneNumber || "--"}</span>
                  </div>
                  <div className="contact-item">
                    <MdMarkEmailRead className="contact-icon" />
                    <span>{user.email || "--"}</span>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="user-card">
              <div className="avatar-wrapper" ref={imageMenuRef}>
                <div
                  className="user-avatar"
                  onClick={() => setShowImageOptions(!showImageOptions)}
                >
                  {user.clientPhoto ? (
                    <img
                      src={user.clientPhoto}
                      alt="profile"
                      className="avatar-image"
                    />
                  ) : (
                    <div className="avatar-placeholder">
                      <FaUser size={24} />
                    </div>
                  )}

                  {imageUploading && (
                    <div className="avatar-loader">
                      <div className="spinner"></div>
                    </div>
                  )}

                  <div className="edit-badge">
                    <FaEdit size={12} />
                  </div>
                </div>

                {showImageOptions && (
                  <div className="image-menu">
                    {user.clientPhoto && (
                      <button
                        className="image-menu-item"
                        onClick={() => window.open(user.clientPhoto, "_blank")}
                      >
                        👁 View Photo
                      </button>
                    )}

                    <button
                      className="image-menu-item"
                      onClick={() => fileInputRef.current.click()}
                    >
                      ⬆ Upload New
                    </button>
                  </div>
                )}
              </div>

              <div className="user-info">
                <h3>{user.name || "--"}</h3>
                <div className="user-contact">
                  <div className="contact-item">
                    <FaPhone className="contact-icon" />
                    <span>{user.phoneNumber || "--"}</span>
                  </div>
                  <div className="contact-item">
                    <MdMarkEmailRead className="contact-icon" />
                    <span>{user.email || "--"}</span>
                  </div>
                </div>
              </div>

              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleImageUpload}
              />
            </div>

            <div className="sidebar-nav">
              <button
                className={`nav-item ${activeTab === "profile" ? "active" : ""}`}
                // onClick={() => setActiveTab("profile")}
                onClick={() => handleTabChange("profile")}
              >
                <FaUser className="nav-icon" />
                <span className="profile-component-nav-button">Profile Information</span>
              </button>
              {isTestUser && (
                <button
                  className={`nav-item ${activeTab === "orders" ? "active" : ""}`}
                  // onClick={() => setActiveTab("orders")}
                  onClick={() => handleTabChange("orders")}
                >
                  <MdShoppingBag className="nav-icon" />
                  <span className="profile-component-nav-button">Order History</span>
                </button>
              )}
              <button className="nav-item logout-btn" onClick={handleLogout}>
                <FiLogOut className="nav-icon" />
                <span className="profile-component-nav-button">Logout</span>
              </button>
            </div>
          </div>

          {/* Main Content */}
          <div className="profile-content">
            {activeTab === "profile" && (
              <div className="tab-content">

                {isProfileIncomplete && (
                  <div className="profile-warning-banner">
                    <div className="warning-icon-wrapper">
                      <MdWarningAmber className="profile-warning-icon" />
                    </div>

                    <div className="warning-content">
                      <div className="warning-title">Profile Incomplete</div>
                      <div className="warning-text">
                        Kindly update your Name, Email, and Phone Number to enable order placement.
                      </div>
                    </div>
                  </div>
                )}
                {/* Account Information */}
                <div className="content-card">
                  <div className="card-header">
                    <h2>Account Information</h2>
                    <button
                      className="update-btn"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading ? "Updating..." : "Update Profile"}
                    </button>
                  </div>

                  <form className="profile-form">
                    <div className="form-grid">
                      <div className="profile-form-group">
                        <label className="profile-form-label">Full Name<span className="required-star">*</span></label>
                        <input
                          type="text"
                          className="profile-form-input"
                          value={editProfileData.name}
                          onChange={(e) =>
                            setEditProfileData({
                              ...editProfileData,
                              name: e.target.value,
                            })
                          }
                          placeholder="Enter your full name"
                        />
                      </div>

                      <div className="profile-form-group">
                        <label className="profile-form-label">Email Address<span className="required-star">*</span></label>
                        <input
                          type="email"
                          className="profile-form-input"
                          value={editProfileData.email}
                          onChange={(e) =>
                            setEditProfileData({
                              ...editProfileData,
                              email: e.target.value,
                            })
                          }
                          placeholder="Enter your email"
                        />
                      </div>

                      <div className="profile-form-group">
                        <label className="profile-form-label">Phone Number<span className="required-star">*</span></label>
                        <input
                          type="text"
                          className="profile-form-input"
                          value={editProfileData.phoneNumber}
                          onChange={(e) =>
                            setEditProfileData({
                              ...editProfileData,
                              phoneNumber: e.target.value,
                            })
                          }
                          placeholder="Enter your phone number"
                        />
                      </div>
                    </div>
                  </form>
                </div>

                {/* Saved Addresses */}
                <div className="content-card">
                  <div className="card-header">
                    <h2>Saved Addresses</h2>
                    <button
                      className="add-address-btn"
                      onClick={() => {
                        setSelectedAddress(null);
                        setShowAddressPopup(true);
                      }}
                    >
                      + Add New Address
                    </button>
                  </div>

                  <div className="addresses-grid">
                    {user?.customerAddress?.length > 0 ? (
                      user.customerAddress.map((addr, index) => (
                        <div className="address-card" key={index}>
                          <div className="profile-address-header">
                            <div className="address-title">
                              <h4>{addr.name}</h4>
                              {addr.isDefault && (
                                <span className="default-badge">Default</span>
                              )}
                            </div>
                            <div className="address-actions">
                              <div
                                className="options-trigger"
                                onMouseEnter={() => setShowOptionsIndex(index)}
                                onMouseLeave={() => setShowOptionsIndex(null)}
                              >
                                <BsThreeDotsVertical />
                                {showOptionsIndex === index && (
                                  <div className="options-menu">
                                    <button
                                      className="option-item"
                                      onClick={() => {
                                        setSelectedAddress(addr);
                                        setShowAddressPopup(true);
                                      }}
                                    >
                                      <FaEdit />
                                      Edit
                                    </button>
                                    <button
                                      className="option-item delete"
                                      onClick={() => handleDeleteAddress(addr.id)}
                                    >
                                      <MdDeleteOutline />
                                      Delete
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="address-details">
                            <p className="address-line">
                              <FaMapMarkerAlt className="address-icon" />
                              {addr.addressLineOne}
                            </p>
                            <p className="address-sub-line">
                              {addr.city}, {addr.state} - {addr.pinCode}
                            </p>
                            <p className="address-line">
                              <FaPhone className="address-icon" />
                              {addr.phoneNumber}
                            </p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="empty-addresses">
                        <FaMapMarkerAlt size={48} className="empty-icon" />
                        <h3>No addresses saved</h3>
                        <p>Add your first address to get started</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {activeTab === "orders" && (
              <div className="tab-content">
                <div className="content-card orders-card">
                  <MyOrders isInProfile={true} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Address Popup */}
      {showAddressPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <div className="popup-header">
              <h3>{selectedAddress ? "Edit Address" : "Add New Address"}</h3>
              <button
                className="popup-close"
                onClick={() => setShowAddressPopup(false)}
              >
                ×
              </button>
            </div>
            <AddressPopupPage
              address={selectedAddress}
              onClose={() => setShowAddressPopup(false)}
              onSuccess={fetchProfile}
            />
          </div>
        </div>
      )}

      <div className="profile-footer">
        {/* <Footer /> */}
      </div>
    </div>
  );
};

export default ProfilePage;